<template>
    <div class="widget">
        <h3>{{title}}</h3>
        <i class="widget__handle mdi mdi-cursor-move" v-if="draggable"></i>
        <loader v-bind="loader">
            <slot/>
        </loader>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import Loader from '@/components/general/Loader';

    @Component({
        components: {
            Loader
        }
    })
    export default class WidgetWrapper extends Vue {
        @Prop({type: Boolean, default: true})
        draggable;
        @Prop({type: Object, required: true, default: () => ({loading: false, error: false})})
        loader;
        @Prop({required: true, type: String})
        title;
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/WidgetWrapper.vue